import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EQCompanyData} from "../../models/serverModels/EQCompanyData";
import {EQWorkOrder, WorkOrderListParams} from "../../models/serverModels/workOrder/EQWorkOrder";

const rootApi = process.env.REACT_APP_API_KEY;

const workOrder = axios.create({
  baseURL: rootApi,
});

export const getList = async (params: WorkOrderListParams): Promise<ResponseList<EQWorkOrder>> =>
  workOrder({
    url: "/WorkOrderList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/WorkOrder/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const create = async (
  params: Params.Create<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/WorkOrder`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  workOrder({
    url: `/WorkOrder/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQWorkOrder>
): Promise<ResponseItem<EQWorkOrder>> =>
  workOrder({
    url: `/WorkOrder/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const RequestedList = async (params: Params.GetList): Promise<ResponseList<EQWorkOrder>> =>
  workOrder({
    url: "/RequestedList",
    method: "get",
    params,
  }).then((res) => res.data);

export const maintenanceList = async (params: Params.GetList): Promise<ResponseList<EQWorkOrder>> =>
  workOrder({
    url: `/maintenanceList/${params.state}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const RecordList = async (params: WorkOrderListParams): Promise<ResponseList<EQWorkOrder>> =>
  workOrder({
    url: `/RecordList`,
    method: "get",
    params,
  }).then((res) => res.data);

export const ChangeTipUpdate = async (
  params: Params.Update<EQCompanyData>
): Promise<ResponseItem<EQCompanyData>> =>
  workOrder({
    url: `/UpdateCompanyData`,
    method: "put",
    data: params,
  }).then((res) => res.data);
